module.exports = __webpack_public_path__ + "img/47.9ab2fc93.jpg";